import { useEffect, useState } from "react";
import { History, AlertTriangle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import api from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });

function PinAge({ d }) {
  if (d.pin_age_days == null) return null;
  const left = d.pin_expires_in_days;
  const cls = left <= 0 ? "text-red-400" : left <= 7 ? "text-amber-400" : "text-muted-foreground";
  return <p className={`text-xs ${cls}`} data-testid="store-pin-age">PIN cambiato {d.pin_age_days} giorni fa · {left <= 0 ? "scaduto: verrà chiesto il rinnovo al prossimo accesso" : `rinnovo richiesto tra ${left} giorni`}</p>;
}

export function StoreLoginsDialog({ store, onClose }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!store) return;
    setData(null);
    api.storeLogins(store.id).then(setData).catch(() => setData({ logins: [] }));
  }, [store]);
  return (
    <Dialog open={!!store} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="store-logins-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><History className="h-4 w-4" /> Accessi · {store?.name}</DialogTitle>
        </DialogHeader>
        {data && (
          <>
            <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
              <span>{data.logins.length} accessi recenti</span>
              <span>{data.distinct_ips} indirizzi IP diversi</span>
            </div>
            <PinAge d={data} />
            {data.logins.length === 0 ? (
              <p className="text-sm text-muted-foreground py-6 text-center">Nessun accesso registrato (lo storico parte da oggi).</p>
            ) : (
              <div className="max-h-[50vh] overflow-y-auto rounded-lg border border-border">
                <table className="w-full text-xs">
                  <thead className="bg-secondary/60 sticky top-0"><tr className="text-left"><th className="p-2">Data e ora</th><th className="p-2">Dispositivo</th><th className="p-2">IP</th><th className="p-2">Sessione</th></tr></thead>
                  <tbody>
                    {data.logins.map((l) => (
                      <tr key={l.id} className={`border-t border-border ${l.rare_ip ? "bg-amber-500/10" : ""}`} data-testid={`store-login-row-${l.id}`}>
                        <td className="p-2 whitespace-nowrap">{fmt(l.created_at)}</td>
                        <td className="p-2">{l.device}{l.pin_expired && <span className="ml-1 text-red-400">· PIN scaduto</span>}</td>
                        <td className="p-2 font-mono-code">{l.ip}{l.rare_ip && <span className="ml-1 inline-flex items-center gap-0.5 text-amber-400" title="IP visto una sola volta: verifica che sia un accesso legittimo"><AlertTriangle className="h-3 w-3" /> nuovo</span>}</td>
                        <td className="p-2 text-muted-foreground">{l.remember ? "30 giorni" : "12 ore"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <p className="text-[11px] text-muted-foreground">Le righe evidenziate indicano un IP mai visto prima per questa sede: un possibile uso anomalo del PIN. In caso di dubbi usa "Cambia PIN" o "PIN dimenticato".</p>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
